import cmsPageQuery from '~layers/app/graphql/cmsPage.gql'
import type { StrapiCmsPage } from '~layers/app/types/strapi'

export function useStrapiCms<T = StrapiCmsPage>(
  documentId: string,
  status: string = 'PUBLISHED',
  query: Parameters<typeof useAsyncQuery>[0] = cmsPageQuery,
  alias: string = '',
) {
  const { public: config } = useRuntimeConfig()
  const locale = config.strapiLocale
  const strapiData = ref<T | null>()
  const strapiError = ref<Error | null | undefined>(null)

  async function getStrapiData() {
    const { client } = useApolloClient('default')
    try {
      const { data } = await client.query<{
        [alias: string]: { data: { data: T } }
      }>({
        query,
        variables: {
          documentId,
          locale,
          status,
        },
      })
      strapiData.value = alias ? data?.[alias] : data
    }
    catch (e) {
      strapiError.value = e
    }

    if (strapiError.value) {
      console.error(strapiError.value)
    }
  }

  return {
    getStrapiData,
    strapiData,
    strapiError,
  }
}
